import { MINIMUM_PROFIT, MINIMUM_PROFIT_UNDER_5000 } from './constant.js';

export const formatFullTime = (t) => (`${t}`.length == 1 ? `0${t}` : t);

export const makeMinProfit = ({ price = 5000, is_digital_product }) =>
  is_digital_product || price >= 5000 ? MINIMUM_PROFIT : MINIMUM_PROFIT_UNDER_5000;
